module.exports = __webpack_public_path__ + "img/bg.4a480b35.jpg";